import {Column} from 'react-table'
import {DataCSRItem} from '../../core/_models'
import {CSRCustomHeader} from './CSRCustomHeader'
import {CSRItemAll} from './CSRItemAll'
import {CSRItemDate} from './CSRItemDate'
import {CSRItemMissed} from './CSRItemMissed'
import {CSRItemOutbound} from './CSRItemOutbound'
import {CSRItemInbound} from './CSRItemInbound'

const CSRColumns: Column<DataCSRItem>[] = [
  {
    Header: (props) => <CSRCustomHeader tableProps={props} title='Период' className='min-w-250px text-gray-700' />,
    accessor: 'date',
    Cell: ({...props}) => <CSRItemDate data={props.data[props.row.index].date} />,
  },

  {
    Header: (props) => <CSRCustomHeader tableProps={props} title='Всего' className='min-w-125px text-gray-700' />,
    accessor: 'total',
    Cell: ({...props}) => (
      <CSRItemAll data={props.data[props.row.index].total} date={props.data[props.row.index].date} />
    ),
  },
  {
    Header: (props) => <CSRCustomHeader tableProps={props} title='Входящие' className='min-w-125px text-gray-700' />,
    accessor: 'inbound',
    Cell: ({...props}) => (
      <CSRItemInbound data={props.data[props.row.index].inbound} date={props.data[props.row.index].date} />
    ),
  },
  {
    Header: (props) => <CSRCustomHeader tableProps={props} title='Исходящие' className='min-w-125px text-gray-700' />,
    accessor: 'outbound',
    Cell: ({...props}) => (
      <CSRItemOutbound data={props.data[props.row.index].outbound} date={props.data[props.row.index].date} />
    ),
  },
  {
    Header: (props) => <CSRCustomHeader tableProps={props} title='Пропущенные' className='min-w-125px text-gray-700' />,
    accessor: 'missed',
    Cell: ({...props}) => (
      <CSRItemMissed data={props.data[props.row.index].missed} date={props.data[props.row.index].date} />
    ),
  },
]

export {CSRColumns}
